module.exports = __webpack_public_path__ + "6554f801e654dff02c5a314f54e1f407.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/photo.png
// module id = 221
// module chunks = 0